// WIN36 hero slideshow: crossfades slides every N seconds; dashes switch slides.
// Pauses when the tab is hidden, for reduced-motion users, and while a slide is selected in the theme editor.
(() => {
  document.querySelectorAll('[data-w36-slideshow]').forEach((hero) => {
    const slides = [...hero.querySelectorAll('.w36-hero__slide')];
    const dots = [...hero.querySelectorAll('.w36-hero__dot')];
    if (slides.length < 2) return;
    const interval = (parseInt(hero.dataset.interval, 10) || 5) * 1000;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let current = 0;
    let timer = null;
    let held = false;

    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === current);
        slide.setAttribute('aria-hidden', i === current ? 'false' : 'true');
      });
      dots.forEach((dot, i) => dot.setAttribute('aria-current', i === current ? 'true' : 'false'));
    };
    const stop = () => {
      clearInterval(timer);
      timer = null;
    };
    const start = () => {
      stop();
      if (reduced || held || hero.dataset.autoplay !== 'true') return;
      timer = setInterval(() => show(current + 1), interval);
    };

    dots.forEach((dot, i) =>
      dot.addEventListener('click', () => {
        show(i);
        start();
      })
    );
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));

    // Theme editor: show the slide being edited
    document.addEventListener('shopify:block:select', (event) => {
      const i = slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
      if (i < 0) return;
      held = true;
      stop();
      show(i);
    });
    document.addEventListener('shopify:block:deselect', () => {
      held = false;
      start();
    });

    show(0);
    start();
  });
})();
